import { useEffect } from 'react';

export function useCyclicEffect(everyMs: number, effect: () => void) {
    useEffect(() => {
        effect();
        const int = setInterval(effect, everyMs);
        return () => clearInterval(int);
    }, [effect]);
}
